import { media, styled } from '@styles';
import { Container } from '@components/templates/Container';

import contactImage from 'images/contacts/contacts-bg.png';

export const Background = styled.div`
  padding: 151px 0 127px;
  background-color: #f1f1f0;
  background-image: url(${contactImage.src});
  background-position: left bottom;
  background-repeat: no-repeat;

  ${media.largeScreen`
    padding: 81px 0 80px;
  `}
  ${media.mediumScreen`
    background-size: contain;
  `}
  ${media.smallScreen`
    padding: 60px 0 60px;
  `}
`;

export const Content = styled(Container)`
  display: flex;
  ${media.mediumScreen`
    flex-direction: column;
    align-items: center;
  `}
`;

export const Form = styled.div`
  width: 50%;
  padding-left: 203px;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  ${media.largeScreen`
    padding-left: 152px;
  `}
  ${media.mediumScreen`
    border-left: none;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding-left: 0;
    padding-top: 70px;
  `}
  ${media.smallScreen`
    padding-top: 50px;
    width: 100%;
  `}
`;

export const Title = styled.h3`
  width: 100%;
  margin-bottom: 50px;
  font-family: ${(props) => props.theme.typography.thinFontFamily};
  font-size: ${(props) => props.theme.typography.h3FontSize};
  line-height: 110%;
  ${media.largeScreen`
    line-height: 130%;
  `}
  ${media.mediumScreen`
    margin-bottom: 40px;
    text-align: center;
  `}
  ${media.smallScreen`
    margin-bottom: 20px;
  `}
`;

export const Loader = styled.div`
  ${media.mediumScreen`
    font-size: 16px;
  `}
  ${media.smallScreen`
    font-size: 14px;
  `}
`;

export const SuccessMessage = styled.div`
  padding: 75px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #e7e7e6;
  border-radius: 4px;

  ${media.largeScreen`
    padding: 75px 35px;
  `}
  ${media.smallScreen`
    padding: 70px 10px;
  `}

  & > p {
    font-family: ${(props) => props.theme.typography.extraFontFamily};
    font-size: ${(props) => props.theme.typography.smallFontSize};
    text-align: center;
    line-height: 160%;
  }
`;
